export default __webpack_public_path__ + "locales/ru/Errors.json?hash=fb960fd371090e03bc0d8fa75d5dafef";